const envTranslations = JSON.parse(process.env.REACT_APP_PT_TRANSLATIONS || '{}');

export const pt = {
  translations: envTranslations,
};
